import { resetSingularitySectionRewriteDuplicateAvoider } from "./sections";

export function singularityHandleDocumentSwitch() {
    resetSingularitySectionRewriteDuplicateAvoider();

    console.log("TODO: clear jobs related to the old document on document switch...");
  }